module.exports = __webpack_public_path__ + "fonts/iconfont.4bcfa883.ttf";